import { Phone, CalendarCheck } from "lucide-react";
import { BUSINESS } from "@/lib/api";

export default function MobileStickyBar({ onOpenBooking }) {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#0B3A5B]/10 shadow-[0_-12px_30px_-12px_rgba(11,58,91,0.2)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="px-3 py-2.5 flex gap-2">
        <a
          href={`tel:${BUSINESS.phone}`}
          data-testid="sticky-call-button"
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full border border-[#0B3A5B]/15 text-[#0B3A5B] font-semibold text-sm"
        >
          <Phone className="h-4 w-4" />
          Appeler
        </a>
        <button
          data-testid="sticky-booking-button"
          onClick={onOpenBooking}
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-[#1E88C8] text-white font-semibold text-sm"
        >
          <CalendarCheck className="h-4 w-4" />
          Prendre RDV
        </button>
      </div>
    </div>
  );
}
